import type { FC } from 'react'

import { Skeleton } from '@/components/ui/skeleton.tsx'

export interface Props {}

export const VideoSkeleton: FC<Props> = () => {
  return <Skeleton className="h-[calc(100vh-100px)] w-8/12 rounded" />
}
